import React, { FC, useEffect, useState, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useAutoApproval, AutoApprovalDTO } from 'hooks/useAutoApproval';

import AutoApprovalList from 'components/AutoApprovalList';
import ConfirmModal from 'components/ConfirmModal';

import {
  InitialContainer,
  ContentWrapper,
  CreateApprovalButton,
} from './styles';

interface DataFilteredInterface {
  active: AutoApprovalDTO[];
  inactive: AutoApprovalDTO[];
  draft: AutoApprovalDTO[];
}

const InitialScreenWithData: FC = () => {
  const {
    data,
    removeAutoApproval,
    updateStatusAutoApproval,
    getCurrentDraftAutoApproval,
  } = useAutoApproval();
  const history = useHistory();
  const [dialogData, setDialogData] = useState({
    message: '',
    id: 0,
    type: '',
  });
  const [showDialog, setShowDialog] = useState(false);
  const [dataFiltered, setDataFiltered] = useState<DataFilteredInterface>({
    active: [],
    draft: [],
    inactive: [],
  });

  useEffect(() => {
    const active: AutoApprovalDTO[] = [];
    const draft: AutoApprovalDTO[] = [];
    const inactive: AutoApprovalDTO[] = [];

    data.forEach((item) => {
      switch (item.status) {
        case 'R':
          draft.push(item);
          break;
        case 'A':
          active.push(item);
          break;
        case 'I':
          inactive.push(item);
          break;
        default:
          break;
      }
    });

    setDataFiltered({
      active,
      draft,
      inactive,
    });
  }, [data]);

  console.log('(DEV) aprovações filtradas', dataFiltered);

  const handleRemoveAutoApproval = useCallback(
    async (id) => {
      removeAutoApproval(id);
    },
    [data],
  );

  const onAcceptActions = {
    active: (id: number) => {
      updateStatusAutoApproval(id);
      setShowDialog(false);
    },
    inactive: (id: number) => {
      handleRemoveAutoApproval(id);
      setShowDialog(false);
    },
    delete: (id: number) => {
      removeAutoApproval(id);
      setShowDialog(false);
    },
  };

  const handleEditDraftAutoApproval = async (id: number) => {
    // FIXME: Create new request, and fill all states with context initial values
    await getCurrentDraftAutoApproval(id);
    history.push('/aprovacao-automatica/edit');
    // await getCurrentAutoApproval(id);
  };

  const handleReviewActiveAutoApproval = async (id: number) => {
    // FIXME: Create new request, and fill all states with context initial values
    await getCurrentDraftAutoApproval(id);
    history.push('/revisao');
    // await getCurrentAutoApproval(id);
  };

  const handleDialogActions = (type: string, id: number) => {
    switch (type) {
      case 'inactive': {
        setDialogData({
          message: 'Tem certeza que deseja remover esta aprovação automática?',
          id,
          type: 'inactive',
        });
        setShowDialog(true);
        break;
      }
      case 'active': {
        setDialogData({
          message:
            'Tem certeza que deseja desativar esta aprovação automática?',
          id,
          type: 'active',
        });

        setShowDialog(true);
        break;
      }
      case 'draft': {
        setDialogData({
          message: 'Tem certeza que deseja ativar esta aprovação automática?',
          id,
          type: 'active',
        });

        setShowDialog(true);
        break;
      }

      case 'delete': {
        setDialogData({
          message: 'Tem certeza que deseja apagar este rascunho?',
          id,
          type: 'delete',
        });

        setShowDialog(true);
        break;
      }
      default:
        break;
    }
  };

  const createNewApproval = () => {
    history.push('/aprovacao-automatica/create');
  };

  return (
    <>
      {showDialog && (
        <ConfirmModal
          title={dialogData.message}
          handleOnReject={() => setShowDialog(false)}
          handleOnAccept={
            // eslint-disable-next-line no-nested-ternary
            dialogData.type === 'active'
              ? () => onAcceptActions.active(dialogData.id)
              : dialogData.type === 'inactive'
              ? () => onAcceptActions.inactive(dialogData.id)
              : () => onAcceptActions.delete(dialogData.id)
          }
        />
      )}
      <InitialContainer>
        <ContentWrapper>
          <h3>Aprovação automática +MAISACESSO</h3>
          <p>
            Com a aprovação automática, você pode definir regras na concessão do
            crédito, que aprovarão automaticamente estudantes que atenderem aos
            critérios.
          </p>
          <CreateApprovalButton onClick={(): void => createNewApproval()}>
            Criar nova aprovação automática
          </CreateApprovalButton>
        </ContentWrapper>

        {dataFiltered.draft.length > 0 && (
          <AutoApprovalList
            type="draft"
            title="Automações em rascunho"
            data={dataFiltered.draft}
            onRemovePress={(id: number) => handleDialogActions('delete', id)}
            onEditPress={(id: number) => handleEditDraftAutoApproval(id)}
          />
        )}

        {dataFiltered.active.length > 0 && (
          <AutoApprovalList
            type="active"
            title="Automações ativas"
            data={dataFiltered.active}
            onRemovePress={(id: number) => handleDialogActions('active', id)}
            onEditPress={(id: number) => handleReviewActiveAutoApproval(id)}
          />
        )}

        {dataFiltered.inactive.length > 0 && (
          <AutoApprovalList
            type="inactive"
            title="Automações desativadas"
            data={dataFiltered.inactive}
            onRemovePress={(id: number) => handleDialogActions('inactive', id)}
            onEditPress={(id: number) => handleDialogActions('draft', id)}
          />
        )}
      </InitialContainer>
    </>
  );
};

export default InitialScreenWithData;
